module.exports = __webpack_public_path__ + "img/goal-poster.ce8a3152.jpg";